import { render, staticRenderFns } from "./MainSiteNav.vue?vue&type=template&id=21d7139b&scoped=true&"
import script from "./MainSiteNav.vue?vue&type=script&lang=js&"
export * from "./MainSiteNav.vue?vue&type=script&lang=js&"
import style0 from "./MainSiteNav.vue?vue&type=style&index=0&id=21d7139b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d7139b",
  null
  
)

export default component.exports